// Home页面相关的类型定义和枚举

export const enum QuickActionType {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
  TRANSFER = 'transfer',
  EXCHANGE = 'exchange'
}

export const enum BalanceDisplayMode {
  VISIBLE = 'visible',
  HIDDEN = 'hidden'
}

export const enum ButtonActionType {
  Deposit = 'deposit',
  Remittance = 'remittance',
  Exchange = 'exchange',
  More = 'more',
  Transfer = 'transfer'
}

export interface QuickAction {
  type: QuickActionType
  label: string
  icon: string
  route: string
}

export interface BalanceInfo {
  total: string
  currency: string
  change24h: string
  displayMode: BalanceDisplayMode
}


export interface ButtonItem {
  actionType: ButtonActionType
  icon: string
  text: string
}
